export const isStringEmptyOrWhitespace = (str?: string) => {
    if (!str) return true;
    return str.trim() === "";
}